import api from "../../../api/index"

export function doctorsData(sd, ed){
    if(sd && ed && sd!="undefined" && ed !="undefined" && sd !="null" && ed !="null"){
        return api.get(`my-consult-doctor-bookings?startDate=${sd}&endDate=${ed}`);
    }
}
